module.exports = __webpack_public_path__ + "img/gzrw2.60314107.png";